
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class VideoPlayer extends Vue {
  @Prop({ type: String, required: true }) src!: string
  @Prop({ type: String, required: false, default: undefined }) poster?: string
  @Prop({ type: String, required: false, default: 'video/mp4' }) type!: string
}
